export function createCaseWhenSql(
    mapping: [string, boolean][],
    field: string,
    prepareCondition: (condition: string) => string,
    yesValue: string,
    noValue: string,
): string {
    const cases = mapping
        .map(([
                  condition,
                  value,
              ]) => `when '${prepareCondition(condition)}' then '${value ? yesValue : noValue}'`);

    return `
case ${field}
${cases.join('\n')}
else '${noValue}'
end`;
}
